<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="label"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="true"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :multiple="true"
    :hide-selected="true"
    :close-on-select="false"
    class="multiselect-primary"
    inputContainerClass="d-flex"
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="singleLabel">
      <span class="teste">{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="option" slot-scope="{ option }"> {{ option.nome }} - {{ option.nome_tipo }} </template>
    <template slot="tag" slot-scope="{ option, remove }" class="d-flex">
      <span class="multiselect__tag">
        <span>{{ option.nome }} - {{ option.nome_tipo }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>

    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'requireSite',
    'siteSelected',
    'validateGroup'
  ],

  data() {
    return {
      selected: new Array(),
      options: new Array(),
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (this.validateGroup) {
        if (this.adicionarItemSeIdGrupoUnico(e)) {
          this.$emit('input', e);
          let arr = new Array();
          if (e == null) {
            this.$emit('selectChange', 'ids_metodo_pagamento', null);
            return;
          }
          e.forEach((el) => {
            arr.push(el.id);
          });
          this.$emit('selectChange', 'ids_metodo_pagamento', arr);
          this.$emit('focus');
        } else {
          this.selected.pop();
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: 'O template já possui um método cadastrado com o grupo que está sendo adicionado.',
            type: 'error'
          });
        }
      } else {
        this.$emit('input', e);
        let arr = new Array();
        if (e == null) {
          this.$emit('selectChange', 'ids_metodo_pagamento', null);
          return;
        }
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'ids_metodo_pagamento', arr);
        this.$emit('focus');
      }
    },
    label({ nome }) {
      return nome;
    },
    setValue(value) {
      this.selected = new Array();
      if (value) {
        value.forEach((el) => {
          this.selected.push(this.options.find((option) => option.id === el));
        });
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions(site, nameField) {
      if (this.requireSite && !site) {
        this.options = [];
      } else {
        this.isLoading = true;
        let filtro = `business_logic.metodo_pagamento_site.id_empresa=${this.$store.state.user.info.id_empresa} and business_logic.metodo_pagamento_site.ativo=true `;
        if (site) {
          if (typeof site == 'number') {
            filtro += `AND business_logic.metodo_pagamento_site.id_localidade_web=${site} `;
          } else {
            filtro += `AND business_logic.metodo_pagamento_site.id_localidade_web=${site.id} `;
          }
        }

        if (nameField) {
          filtro += `OR business_logic.metodo_pagamento_site.id in (${nameField})`;
        }
        this.$atenaList
          .getCommon('metodo_pagamento', {
            columns: 'id, nome,id_localidade_web,config_metadata',
            filter: filtro,
            order: 'id',
            related: 'tipo_metodo_pagamento:nome as nome_tipo,id_grupo as id_grupo'
          })
          .then((res) => {
            this.options = [];
            if (this.includeAll) {
              this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
            }
            this.options = this.options.concat(res.data);
            this.setValue(this.nameField);
            this.isLoading = false;
          })
          .catch((err) => {
            this.isLoading = false;
            this.$notify({
              group: 'notifications-default',
              type: 'error',
              title: this.$i18n.t('Erro ao Carregar Dados'),
              text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
            });
          });
      }
    },
    adicionarItemSeIdGrupoUnico(array) {
      const idGruposEncontrados = {};
      const grupoPix = [];
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const idGrupo = item.id_grupo;
        const configMetadata = item.config_metadata ? JSON.parse(item.config_metadata) : null;
        const permiteDeposito = configMetadata?.permiteDeposito ?? false;
        const permiteResgate = configMetadata?.permiteResgate ?? false;

        if (idGrupo == 5 && grupoPix.length < 2) {
          grupoPix.push({ id: item.id, permiteDeposito, permiteResgate });

          if (idGruposEncontrados[idGrupo]) {
            if (
              (permiteDeposito && grupoPix[0].permiteDeposito) ||
              (permiteResgate && grupoPix[0].permiteResgate)
            ) {
              return false;
            }
          }
        } else if (idGrupo == 4 && idGruposEncontrados[idGrupo]) {
          return false;
        }
        idGruposEncontrados[idGrupo] = true;
      }
      return true;
    }
  },
  created() {
    if (this.siteSelected) this.setOptions(this.siteSelected, this.nameField);
    else this.setOptions();
  },
  watch: {
    nameField(value) {
      this.setValue(value);
    },
    siteSelected(site) {
      this.selected = new Array();
      if (site) this.setOptions(site);
    }
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
